import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Logo, Menu, Close } from '../Icons';
import { useAuth } from '../../auth/AuthContext';

function AccountActions() {
  const { isAuthenticated, home, logout } = useAuth();
  if (isAuthenticated) {
    return (
      <>
        <button type="button" className="btn btn--ghost" onClick={() => logout('logout')}>Log out</button>
        <Link to={home} className="btn btn--primary">My dashboard</Link>
      </>
    );
  }
  return (
    <>
      <Link to="/login" className="btn btn--ghost">Log in</Link>
      <Link to="/register" className="btn btn--primary">Get started</Link>
    </>
  );
}

const links = [
  { to: '/how-it-works', label: 'How it works' },
  { to: '/send', label: 'Send luggage' },
  { to: '/become-a-traveller', label: 'Become a traveller' },
  { to: '/search', label: 'Search travellers' },
  { to: '/safety', label: 'Safety' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className={`nav ${scrolled || open ? 'nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <Link to="/" className="brand" aria-label="Routebag home">
          <Logo />
          <span>Routebag</span>
        </Link>

        <nav className={`nav__links ${open ? 'is-open' : ''}`} aria-label="Primary">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? 'is-active' : '')}>
              {l.label}
            </NavLink>
          ))}
          <div className="nav__cta-mobile">
            <AccountActions />
          </div>
        </nav>

        <div className="nav__cta">
          <AccountActions />
        </div>

        <button
          className="nav__toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <Close /> : <Menu />}
        </button>
      </div>
    </header>
  );
}
